<template>
  <div id="trx-payment-purpose-container">
    <f7-list form class="form-group">
      <f7-list-input
          input-id     ="paymentPurpose"
          id           ="paymentPurposeInput"
          name         ="paymentPurpose"
          class        ="clickable-row use-chevron"

          v-show       ="showFormInput.root.paymentPurpose"
          :label       ="$t('beneficiary-payment-purpose')"
          :placeholder ="$t('beneficiary-select-payment-purpose')"
          :value       ="paymentPurpose"
          @change      ="setPaymentPurpose($event.target.value); validateInput($event.target); setInput('paymentPurpose')"
          autocomplete ="off"
          outline
          floating-label
      >
          <f7-link popover-open=".popover-dropdown-tx-purpose" slot="content-start" class="clickable-item"></f7-link>
      </f7-list-input>

      <f7-popover class="popover-dropdown-tx-purpose dropdown-default dropdown tx" :backdrop="true">
        <f7-list>
            <f7-list-item popover-close link="#"
            v-for="item in paymentPurposeList"
            :key="item.key"
            selected=""
            @click="changePaymentPurpose(item.key); validateInput($event.target); setInput('paymentPurpose')">
              {{item.value}}
            </f7-list-item>
        </f7-list>
      </f7-popover>

      <f7-list-input
          input-id     ="paymentPurposeOther"
          name         ="paymentPurposeOther"
          type         ="text"

          v-show       ="showFormInput.root.paymentPurposeOther"
          :label       ="$t('beneficiary-other-payment-purpose')"
          :placeholder ="$t('beneficiary-other-payment-purpose')"
          :value       ="paymentPurposeOther"
          @input       ="setPaymentPurposeOther($event.target.value); validateInput($event.target); setInput('paymentPurposeOther')"
          autocomplete ="off"
          outline
          floating-label
      ></f7-list-input>
    </f7-list>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {

    },
    mounted (){
      console.log("paymentPurposeList: ", this.paymentPurposeList)
      this.init()
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('transaction', [
          'showFormSet',
          'showFormInput',
          'paymentPurpose',
          'paymentPurposeList',
          'paymentPurposeOther',
      ])
    },
    methods: {
      ...mapActions('transaction', [
          'setPaymentPurpose',
          'setPaymentPurposeOther',
      ]),

      async init(){
          await this.renderDropdown();
      },

      renderDropdown(){
          const self = this;

          self.Dom7('.tx.popover-dropdown-tx-purpose').on('popover:open', function () {
              self.$$(".tx.popover-dropdown-tx-purpose").css({
                  'visibility' : 'hidden',
              });
          });

          self.Dom7('.tx.popover-dropdown-tx-purpose').on('popover:opened', function () {
              var thepopover = self.Dom7('.tx.popover-dropdown-tx-purpose');
              const classes = thepopover[0].firstChild.classList;
              const popoverDirection = classes[1];
              console.log("TX PAYMENT PURPOSE direction: "+popoverDirection)

              const parentPosBottom = document.getElementById('paymentPurpose').getBoundingClientRect().bottom;
              const parentPosLeft = document.getElementById('paymentPurpose').getBoundingClientRect().left;

              self.$$("#paymentPurposeInput").removeClass("dropdown-list").addClass("dropdown-list");

              if(popoverDirection == "on-top" || popoverDirection == "on-left" || popoverDirection == "on-right"){
                self.$$(".tx.popover-dropdown-tx-purpose").css({
                    'visibility' : 'visible',
                    'top' : (parentPosBottom) + 'px',
                    'margin-left' : (parentPosLeft) + 'px'
                });
              } else if(popoverDirection == "on-bottom"){ 
                self.$$(".tx.popover-dropdown-tx-purpose").css({
                    'visibility' : 'visible',
                    'margin-top' : (8) + 'px',
                    'margin-left' : (parentPosLeft) + 'px'
                });
              }
          });

          self.Dom7('.tx.popover-dropdown-tx-purpose').on('popover:closed', function () {
              self.$$("#paymentPurposeInput").removeClass("dropdown-list");            
          });
      },

      changePaymentPurpose(id){
        this.$emit("changePaymentPurpose", id);
      },

      validateInput(inputEl){
        this.$emit("validateInput", inputEl);
      },

      setInput(inputEl){
        this.$emit("setInput", inputEl);
      }
    }
  }
</script>